import {json, texture} from "p3";
import common from "../common";
import { locale, resizeLabelToFitText } from "../utils";
import MenuScene from "./MenuScene";

export default class SettingsScene extends MenuScene {
    constructor() {
        super("settings");

        this._fill = null;
        this._panel = null;

        this._languagePanel = null;

    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this._fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fill.tint = 0x000000;
        this._fill.alpha = 0;
        this._fill.interactive = true;
        this.addChild(this._fill);
        this.resizeFill();

        this._panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        this._panel.width = 380;
        this._panel.height = 550;
        this._panel.x = (common.STAGE_WIDTH/2) - (this._panel.width/2);
        this._panel.y = common.STAGE_HEIGHT;
        this.addChild(this._panel);

        const title = new PIXI.BitmapText(locale('ui_settings_title').toUpperCase(), {
            fontName: "Alghera Pro",
            fontSize: 40,
            align: "center",
            tint: 0x000000
        });
        title.anchor.set(0.5);
        title.position.set(this._panel.width/2, 60);
        this._panel.addChild(title);
        resizeLabelToFitText(title, this._panel.width-60);

        const toggleButton = new P3.ButtonStates(texture("btn_rectangle_out"));
        toggleButton.normalAlt = texture("btn_rectangle_brown_out");
        const normalButton = new P3.ButtonStates(texture("btn_rectangle_brown_out"));

        const buttonData = [
            {id:"sound", icon:"btn_icon_sound_on", iconAlt:"btn_icon_sound_off", state:toggleButton, text:"ui_settings_sound_on", textAlt:"ui_settings_sound_off", settingValue:"muted"},
            {id:"music", icon:"icon_music_on", iconAlt:"icon_music_off", state:toggleButton, text:"ui_settings_music_on", textAlt:"ui_settings_music_off", settingValue:"musicMute"},
            {id:"rate", icon:"icon_rating", state:normalButton, text:"ui_settings_rate"},
            {id:"language", icon:"icon_language", state:normalButton, text:"ui_settings_language"},
            {id:"legal", icon:"icon_legal", state:normalButton, text:"ui_settings_legal"},
        ];

        let currentY = title.y + title.height + 65;

        const savedSettings = common.saveData.settings;

        for (let i in buttonData) {

            let button;
            if (buttonData[i].iconAlt) {
                button = new P3.ToggleButton(buttonData[i].state);
            } else {
                button = new P3.Button(buttonData[i].state);
            }
            button.data = buttonData[i];
            button.id = buttonData[i].id;
            button.position.set(this._panel.width/2, currentY);
            button.overSoundName = "sfx_btn_generic_rollover";
            button.clickSoundName = "sfx_btn_generic_press_00";
            button.signals.click.add(this._onButtonClick, this);
            this._panel.addChild(button);
            let icon = new PIXI.Sprite(texture(buttonData[i].icon));
            icon.anchor.set(0.5);
            icon.x = 100;
            button.icon = icon;
            button._icon.addChild(icon);
            let nameLabel = new PIXI.BitmapText(locale(buttonData[i].text).toUpperCase(), {
                fontName: "Alghera Pro Outline",
                fontSize: 32,
                align: "left",
                tint: 0xFFFFFF
            });
            nameLabel.position.set(-120, 0);
            nameLabel.anchor.set(0, 0.5);
            button._background.addChild(nameLabel);
            button.label = nameLabel;
            resizeLabelToFitText(nameLabel, 180);

            currentY += button.height * 0.8;

            if (buttonData[i].settingValue && savedSettings[buttonData[i].settingValue]) {
                button.toggle = true;
                this._onButtonClick(button);
            }
        }

        this._panel.addChild(this.addCloseButton(this._panel.width, 30));

        this._tweens.push(
            gsap.to(this._panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (this._panel.height/2), ease:Expo.easeOut}),
            gsap.to(this._fill, 0.2, {alpha:0.3, ease:Sine.easeIn})
        );

        this.resize();
    }

    destroy() {

        super.destroy();
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            
        }
    }

    resizeFill(){
        if (this._fill) {
            this._fill.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
            this._fill.width = P3.View.width;
            this._fill.height = P3.View.height;
        }
    }

    _onButtonClick(button) {
        console.log(button.id);
        if (button.data.iconAlt) {
            button.icon.texture = texture(button.toggle ? button.data.iconAlt : button.data.icon);
            button.label.text = locale(button.toggle ? button.data.textAlt : button.data.text).toUpperCase();
            common.saveData.settings[button.data.settingValue] = button.toggle;
            common.saveData.saveGame();
            if (button.data.settingValue == 'muted') {
                P3.audio.mute(button.toggle);
            }
            else if (button.data.settingValue == 'musicMute') {
                button.toggle ? P3.audio.music.pause() : P3.audio.music.play();
            }
        }
        else if (button.id == 'language') {
            this.showLanguagePanel();
        }
        else if (button.id == 'rate') {
            if (!!window.cordova) {
                cordova.plugins.AppReview.requestReview().catch(function() {
                    return cordova.plugins.AppReview.openStoreScreen();
                });
            }
        }
    }

    _onCloseButtonClick() {
        if (this._languagePanel) {
            this.hideLanguagePanel();
        } else {
            this.animateHide();
        }
    }

    showLanguagePanel() {

        this._closeButton.interactive = false;

        this._languagePanel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        this._languagePanel.width = 800;
        this._languagePanel.height = 650;
        this._languagePanel.interactive = true;
        this._languagePanel.position.set(
            (common.STAGE_WIDTH/2) - (this._languagePanel.width/2),
            common.STAGE_HEIGHT,
        );
        this.addChild(this._languagePanel);

        const buttonHolder = new PIXI.Container();
        buttonHolder.x = 0;
        buttonHolder.y = 0;
        this._languagePanel.addChild(buttonHolder);

        const title = new PIXI.BitmapText(locale('ui_settings_language').toUpperCase(), {
            fontName: "Alghera Pro",
            fontSize: 40,
            align: "center",
            tint: 0x000000
        });
        title.anchor.set(0.5);
        title.position.set(this._languagePanel.width/2, 60);
        this._languagePanel.addChild(title);
        resizeLabelToFitText(title, this._panel.width-60);

        this._tweens.push(
            gsap.to(this._closeButton.scale, 0.2, {x:0, y:0, ease:Sine.easeIn, onComplete:() => {
                this._closeButton.x = this._languagePanel.width;
                this._languagePanel.addChild(this._closeButton);
                this._tweens.push(
                    gsap.to(this._closeButton.scale, 0.3, {x:1, y:1, ease:Sine.easeIn, onComplete:() => {
                        this._closeButton.interactive = true;
                    }})
                );
            }}),
            gsap.to(this._languagePanel, 0.2, {y:(common.STAGE_HEIGHT / 2) - (this._languagePanel.height/2), ease:Expo.easeOut})
        );
        
        const state = new P3.ButtonStates(PIXI.Texture.EMPTY);
        let currentX = 0;
        let currentY = 0;
        const areaWidth = this._languagePanel.width * 0.9;
        const areaHeight = (this._languagePanel.height - buttonHolder.y) * 0.7;
        const boxWidth = 200;
        const boxHeight = 50;
        const gridWidth = 3;
        const gridHeight = 7;
        const xMargin = (areaWidth - (boxWidth * gridWidth)) / (gridWidth-1); 
        const yMargin = (areaHeight - (boxHeight * gridHeight)) / (gridHeight-1); 
        
        const languageTitles = json("locale").languages;
        for (let i in languageTitles) {
            let button = new P3.Button(state);
            button.id = i;
            button.position.set(
                ((this._languagePanel.width - areaWidth)/2) + (currentX * (boxWidth)) + (boxWidth/2) + (currentX * xMargin),
                ((this._languagePanel.height - areaHeight)/2) + (currentY * (boxHeight)) + (boxHeight/2) + (currentY * yMargin)
            );
            let buttonBacking = new PIXI.Sprite(PIXI.Texture.WHITE);
            buttonBacking.alpha = 0;
            buttonBacking.anchor.set(0.5, 0);
            button.signals.click.add(this._onLanguageChange, this);
            button.addChild(buttonBacking);
            let text = languageTitles[i].en;
            if (i == 'ar') {
                text = text.split("").reverse().join("");
            }
            let buttonText = new PIXI.BitmapText(text, {
                fontName: "alghera_pro_languages",
                fontSize: 35,
                align: "center",
                tint: 0x000000,
                maxWidth: 200
            });
            buttonText.anchor.set(0.5, 0);
            button.addChild(buttonText);
            buttonHolder.addChild(button);
            buttonBacking.width = buttonText.width;
            buttonBacking.height = buttonText.height;

            if (currentX >= gridWidth-1) {
                currentX = 0;
                currentY ++;
            } else {
                currentX ++;
            }
        }
    }

    hideLanguagePanel() {
        this._closeButton.interactive = false;

        this._tweens.push(
            gsap.to(this._closeButton.scale, 0.2, {x:0, y:0, ease:Sine.easeIn, onComplete:() => {
                this._closeButton.x = this._panel.width;
                this._panel.addChild(this._closeButton);
                this._tweens.push(
                    gsap.to(this._closeButton.scale, 0.3, {x:1, y:1, ease:Sine.easeIn, onComplete:() => {
                        this._closeButton.interactive = true;
                    }})
                );
            }}),
            gsap.to(this._languagePanel, 0.2, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                this.removeChild(this._languagePanel);
                this._languagePanel = null;
            }})
        );
    }

    _onLanguageChange(button) {
        common.config.language = button.id;
        common.saveData.settings.language = button.id;
        common.saveData.saveGame();
        this.signals.next.dispatch();
    }

    animateHide() {
        super.animateHide();
        this._tweens.push(
            gsap.to(this._panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                this.signals.previous.dispatch();
            }}),
            gsap.to(this._fill, 0.2, {alpha:0, ease:Sine.easeIn, onComplete:() => {
                this.removeChild(this._fill);
            }})
        );
    }
}

/**
 * @static
 * @type {MapScene}
 */
SettingsScene.active = null;